import React from 'react';
import { Grid } from '@mui/material';

interface IHeaderLayoutProps {
  children?: React.ReactNode;
  title: string;
}

const HomepageLayout: React.FC<IHeaderLayoutProps> = (
  props: IHeaderLayoutProps,
) => {
  const { children, title } = props;

  return (
    <section
      className='home-content-body Home-HeaderDown'
      style={{ minHeight: 0 }}
    >
      <Grid container>
        <Grid item xs={12}>
          <div className='homepage-header'>
            <div className='homepage-header-title-cont'>
              <h1>{title}</h1>
            </div>
          </div>
        </Grid>
        <div className='HomeDashboard-container'>{children}</div>
      </Grid>
    </section>
  );
};

export default HomepageLayout;
